import { HANDLE_VEHICLE, RESET } from '../actions';

const initialState = {
    vehicleList: [],
    vehicleCopy: []
};

const VehicleDetails = (state = initialState, action) => {
    
    switch (action.type) {
        case HANDLE_VEHICLE:
            return {
                ...state,
                ...action.data
            };
        case RESET:
            return initialState;
        default:
            return state;
    }
};

export default VehicleDetails;